module.exports = __webpack_public_path__ + "static/media/bphtb5.9c874557.png";